<template>
  <ul
    class="nav nav-tabs nav-pills wallet-tabs"
    :class="{ 'settings-nav': isDesktop, 'show_list_horizontal text-nowrap': !isDesktop }"
    id="myTab"
    role="tablist"
  >
    <li v-for="tab in visibleTabs" :key="tab.key" class="nav-item" role="presentation">
      <button
        class="nav-link"
        :class="{ 'active': tab.key === activeMenuSelection, 'xsmall-font-size': !isDesktop }"
        :id="`${tab.key}-tab`"
        data-bs-toggle="tab"
        :data-bs-target="`#${tab.key}`"
        type="button"
        role="tab"
        :aria-controls="tab.key"
        :aria-selected="tab.key === activeMenuSelection"
        @click="$emit('select', tab.key)"
      >
        {{ tab.label.toUpperCase() }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "WalletTabs",
  props: {
    activeMenuSelection: {
      type: String,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    userType: {
      type: Number,
      required: true
    },
    windowWidth: {
      type: Number,
      required: true
    }
  },
  emits: ["select"],
  computed: {
    isDesktop() {
      return 1200 < this.windowWidth;
    },
    visibleTabs() {
      const tabs = [
        { key: "Summary", label: this.labels.summary },
        { key: "Cash", label: this.labels.cash },
        { key: "Equities", label: this.labels.equities },
        { key: "Pending", label: this.labels.pending },
        { key: "Orders", label: this.labels.orders },
        { key: "Trades", label: this.labels.trades },
        { key: "Transfers", label: this.labels.transfers, liveOnly: true },
        { key: "Transactions", label: this.labels.transactions }
      ];

      return tabs.filter((tab) => !tab.liveOnly || 1 === this.userType);
    }
  }
};
</script>

<style scoped>
.wallet-tabs.settings-nav {
  margin-top: 2px;
}
</style>
